import { useState } from 'react';

import { PersonType } from '../../../../../../../../../backend/src/types/types';
import { TrackingEvents } from '../../../../../../../analytics/events';
import { trackCustomEvent } from '../../../../../../../analytics/Mixpanel';
import MultiSelect from '../../../../../../../components/atoms/MultiSelect';
import { transformFilterName } from '../../../../../../../helpers/filterNames';
import { Label } from '@/components/atoms/label';
import FilterPopup from '@/components/molecules/FilterPopup';
import type { MyOptionType, PersonFilters } from '@/types';

const PersonFiltersPopup = ({
  activeFilters,
  setFilters,
  handleClose,
  setActiveFilterCount,
  goToPage,
}: {
  activeFilters: PersonFilters;
  setFilters: (v: PersonFilters) => void;
  handleClose: () => void;
  setActiveFilterCount: (count: number) => void;
  goToPage?: (value: number) => void;
}) => {
  const [personTypeFilters, setPersonTypeFilters] = useState<MyOptionType[]>(activeFilters.personType || []);

  const handleSubmit = () => {
    const newFilters = { ...activeFilters };
    newFilters.personType = personTypeFilters;

    setFilters(newFilters);

    // recount number of active filters
    let count = 0;
    Object.keys(newFilters).forEach((key) => {
      const filterValues = newFilters[key as keyof PersonFilters];
      if (filterValues && Array.isArray(filterValues) && filterValues.length > 0) {
        count += 1;
      }
    });
    setActiveFilterCount(count);

    handleClose();
  };

  const handleClear = () => {
    setFilters({
      personType: [],
    });

    setActiveFilterCount(0);

    handleClose();
  };

  return (
    <FilterPopup
      title="Filter Entities"
      description="Choose which entities to show"
      onApply={handleSubmit}
      onClear={handleClear}
      goToPage={goToPage}
    >
      <div>
        <Label className="mb-2 block">Entity Types</Label>
        <MultiSelect
          placeholder="All entity types"
          options={Object.values(PersonType).map((person) => ({
            label: transformFilterName(person, 'personType'),
            value: person,
          }))}
          selectedOptions={personTypeFilters}
          onChange={(newValue) => {
            trackCustomEvent(TrackingEvents.FilterPersonByType);
            setPersonTypeFilters([...newValue]);
          }}
          className="w-full"
        />
      </div>
    </FilterPopup>
  );
};

export default PersonFiltersPopup;
